import PropTypes from 'prop-types';

/**
utils for accepting DOM elements or react components
as component type to use for rendering
*/
const props = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.any]);
const defaults = 'div';

var componentEl = /*#__PURE__*/Object.freeze({
  __proto__: null,
  props: props,
  defaults: defaults
});

export { componentEl as c, defaults as d, props as p };
